export default __webpack_public_path__ + "static/documentary-ed8c845d1be42e60d58d43a8ad8d3575.webm";